export enum ELocalStorageKey {
  AcceptedPublicOffers = '_po_off_acc',
  FeatureMobileSingIn = '_feat_mobile_sign_in',
  FeatureMusic = '_feat_music',
  UserId = 'userId',
  FeatureBots = '_feat_bots',
  Over18Channels = '_over18_channels',
  PassportId = 'passportId',
  PushToken = 'pushToken',
  CurrentChannelDeeplink = 'currentChannelDeeplink',
  RecentSearched = 'recentSearched',
  InstallationId = 'installationId',
  Home = 'home',
  ReferringLink = 'referring_link',
  HiddenMode = 'hiddenMode',
}

export enum AppNameMappings {
  Aitu = 'Aitu',
  TelecomKz = 'TelecomKz',
  Platonus = 'Platonus'
}

export type TAppName = Lowercase<keyof typeof AppNameMappings>;

export type SubscriptionType = "personal" | "group";
